import React from "react";

function tone(v) {
  if (v <= 0) return "var(--hm-0)";
  if (v < 0.5) return "var(--hm-1)";
  if (v < 1) return "var(--hm-2)";
  return "var(--hm-3)";
}

export default function BookHeatmap({ books, progress, size = "md", showLabels = false }) {
  // sizes control the cell width
  const cols = size === "sm" ? 14 : size === "lg" ? 9 : 14;
  return (
    <div
      className="grid gap-[2px]"
      style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}
      data-testid="book-heatmap"
    >
      {books.map((b) => {
        const v = Number(progress?.[b] || 0);
        const pct = Math.round(v * 100);
        return (
          <div key={b} className="relative group">
            <div
              className="hm-cell"
              style={{ background: tone(v) }}
              title={`${b} · ${pct}%`}
              data-testid={`hm-${b}`}
            />
            {showLabels && (
              <div className="mono text-[9px] text-center mt-1 text-[color:var(--ink-3)] truncate">
                {b}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
